import axios from 'axios';

const lookupPrefix = `${process.env.VUE_APP_MODULE_Bankruptcy}/lookups`;

export default {
  getMainRequestCategories: () => axios.get(`${lookupPrefix}/main-request-categories`),
  getRequestOwnerTypes: () => axios.get(`${lookupPrefix}/request-owner-types`),
  getLegalCapacities: () => axios.get(`${lookupPrefix}/legal-capacities`),
  getCommercialCourts: () => axios.get(`${lookupPrefix}/commercial-courts`),
  getProcedureTypes: () => axios.get(`${lookupPrefix}/procedure-types`),
  getIdentityTypes: () => axios.get(`${lookupPrefix}/identity-types`),
  getPartyTypes: () => axios.get(`${lookupPrefix}/party-types`),
  getFirmTypes: () => axios.get(`${lookupPrefix}/firm-types`),
  getOrganizedEntityTypes: () => axios.get(`${lookupPrefix}/organized-entity-types`),
  getDebtorClassifications: () => axios.get(`${lookupPrefix}/debtor-classifications`),
  getMainRequestStatuses: () => axios.get(`${lookupPrefix}/main-request-statuses`),
  getPartyTypeDebtorClassifications: partyTypeId =>
    axios.get(`${lookupPrefix}/party-type-debtor-classifications`, getQueryParamWithOneFilter('partyTypeId', partyTypeId)),
  getCountryCities: countryId =>
    axios.get(`${lookupPrefix}/country-cities`, getQueryParamWithOneFilter('countryId', countryId)),
  getAssetTypes: () => axios.get(`${lookupPrefix}/asset-types`),
  getRealEstateTypes: () => axios.get(`${lookupPrefix}/real-estate-types`),
  getCurrencies: () => axios.get(`${lookupPrefix}/currencies`),
  getCountries: () => axios.get(`${lookupPrefix}/countries`),
  getRegionsByCountry: countryId => axios.get(`${lookupPrefix}/regions`, getQueryParamsWithFilters(
    [
      {
        field: 'isActive',
        value: 1,
      },
      {
        field: 'countryId',
        value: countryId,
      },
    ])),
  getCitiesByRegion: regionId => axios.get(`${lookupPrefix}/cities`, getQueryParamWithOneFilter('regionId', regionId)),
  getSubRequestTypes: () => axios.get(`${lookupPrefix}/sub-request-types`),
  getSubRequestStatuses: () => axios.get(`${lookupPrefix}/sub-request-statuses`),
  getAttachmentTypes: () => axios.get(`${lookupPrefix}/attachment-types`),
  getGlobalAttachmentTypes: () => axios.get(`${lookupPrefix}/global-attachment-types`),
  getStakeholderTypes: () => axios.get(`${lookupPrefix}/stakeholder-types`),
};
const getQueryParamsWithFilters = filters => ({ params: { query: { filters: filters } } });
const getQueryParamWithOneFilter = (field, value) => ({
  params: {
    query: {
      filters: [{
        field,
        value,
      }],
    },
  },
});
